/**
 * Scroll reveal for `.ee-reveal` elements: adds `.is-visible` once an element enters
 * the viewport. The `ee-js` class on <html> opts in to the hidden start state, so
 * content stays visible if this script never runs. Respects reduced motion.
 */
const root = document.documentElement;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function reveal(elements) {
  for (const element of elements) element.classList.add('is-visible');
}

if (reduceMotion || !('IntersectionObserver' in window)) {
  reveal(document.querySelectorAll('.ee-reveal'));
} else {
  // Elements already on screen when the module runs stay put; only later ones animate.
  reveal(
    [...document.querySelectorAll('.ee-reveal')].filter(
      (element) => element.getBoundingClientRect().top < window.innerHeight
    )
  );
  root.classList.add('ee-js');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const observe = (scope) => {
    for (const element of scope.querySelectorAll('.ee-reveal:not(.is-visible)')) observer.observe(element);
  };

  observe(document);

  // Theme editor: sections re-render in place.
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) reveal(event.target.querySelectorAll('.ee-reveal'));
  });
}
